"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ArticleCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreThemes = require("@vfuk/core-themes");

var _coreContainer = _interopRequireDefault(require("@vfuk/core-container"));

var _coreCardHeader = _interopRequireDefault(require("@vfuk/core-card-header"));

var _coreCardBody = _interopRequireDefault(require("@vfuk/core-card-body"));

var _coreBaseProps = require("@vfuk/core-base-props");

var _ArticleCard = _interopRequireDefault(require("./themes/ArticleCard.theme"));

var Styled = _interopRequireWildcard(require("./styles/ArticleCard.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ArticleCard = function ArticleCard(_ref) {
  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 1 : _ref$level,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? false : _ref$elevation,
      primaryImage = _ref.primaryImage,
      secondaryImage = _ref.secondaryImage,
      headingText = _ref.headingText,
      text = _ref.text,
      primaryButton = _ref.primaryButton,
      secondaryButton = _ref.secondaryButton,
      marketingShout = _ref.marketingShout,
      pill = _ref.pill,
      id = _ref.id,
      dataSelectorPrefix = _ref.dataSelectorPrefix,
      dataAttributes = _ref.dataAttributes,
      localTheme = _ref.localTheme;
  var componentName = 'ArticleCard';
  var articleCardTheme = (0, _coreThemes.useLocalTheme)(componentName, _ArticleCard["default"], localTheme);
  var articleCardAppearance = articleCardTheme.appearance[appearance];
  var containerAppearance = articleCardAppearance.containerAppearance;
  var _articleCardAppearanc = articleCardAppearance.level[level],
      inverseText = _articleCardAppearanc.inverseText,
      primaryButtonAppearance = _articleCardAppearanc.primaryButtonAppearance,
      secondaryButtonAppearance = _articleCardAppearanc.secondaryButtonAppearance,
      inverseButton = _articleCardAppearanc.inverseButton;
  return /*#__PURE__*/_react["default"].createElement(_coreContainer["default"], {
    appearance: containerAppearance,
    elevation: elevation,
    paddingLevel: 0,
    id: id,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    componentName: componentName,
    dataAttributes: dataAttributes
  }, /*#__PURE__*/_react["default"].createElement(Styled.ArticleCard, null, /*#__PURE__*/_react["default"].createElement(_coreCardHeader["default"], {
    primaryImage: _objectSpread(_objectSpread({}, primaryImage), {}, {
      alt: primaryImage.alt || headingText
    }),
    secondaryImage: secondaryImage && _objectSpread(_objectSpread({}, secondaryImage), {}, {
      alt: secondaryImage.alt
    }),
    marketingShout: marketingShout,
    pill: pill,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'card-header')
  }), /*#__PURE__*/_react["default"].createElement(_coreCardBody["default"], {
    heading: {
      text: headingText,
      size: 2,
      level: 2,
      inverse: inverseText
    },
    primaryButton: _objectSpread(_objectSpread({}, primaryButton), {}, {
      appearance: primaryButtonAppearance,
      inverse: inverseButton
    }),
    secondaryButton: _objectSpread(_objectSpread({}, secondaryButton), {}, {
      appearance: secondaryButtonAppearance,
      inverse: inverseButton
    }),
    paragraph: {
      text: text,
      inverse: inverseText
    },
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'card-body')
  })));
};

exports.ArticleCard = ArticleCard;
ArticleCard.displayName = "ArticleCard";
var _default = ArticleCard;
exports["default"] = _default;
//# sourceMappingURL=ArticleCard.js.map